<div [ngClass]="listName === 'default' ? 'card-container' : listName + '-container'" class="mar-top-3">

  <ng-container *ngFor="let cardData of dataList | limit: listLimit || dataList.length; let i = index; trackBy: trackByCardId">

    <!-- Default card layout -->
    <ng-container>
      <a
        [ngClass]="[cardData.cardCss?.mainCard, isPublic ? 'cursor-default' : 'cursor-pointer']"
        (click)="!isPublic ? view(cardData) : null"
        (keydown.enter)="!isPublic ? view(cardData) : null"
        (keydown.space)="!isPublic ? view(cardData) : null"
        role="button"
        tabindex="0"
        class="relative"
        [attr.aria-label]="getCardAriaLabel(cardData)"
      >

        <div *ngIf="cardData?.isCompleted !== null"
          class="status-banner text-center text-[0.875rem] font-bold py-2 rounded-t-lg"
          [ngClass]="{
            'completed': cardData?.status === CourseStatus.Completed,
            'reviewed': cardData?.status === CourseStatus.Reviewed,
            'incomplete': cardData?.status === CourseStatus.Incomplete
          }"
          aria-hidden="true">
          {{ cardData?.status | uppercase }}
        </div>

        <div *ngIf="cardData?.img" [ngClass]="cardData.cardCss?.image" class="relative">
          <img [attr.id]="'card-image-' + (cardData?.id || i)"
            [src]="cardData?.sasToken ? generateUrlWithSasToken(cardData.sasToken, cardData.img) : cardData.img"
            alt=""
            aria-hidden="true" />
        </div>

        <div *ngIf="cardData?.title" [ngClass]="cardData.cardCss?.title" aria-hidden="true">{{ cardData?.title }}</div>
        <div *ngIf="cardData?.summary || cardData?.description" [ngClass]="cardData.cardCss?.summary" aria-hidden="true">
          {{ cardData?.summary ? cardData?.summary : cardData?.description }}
        </div>
        <!-- <div *ngIf="cardData?.author" class="card-author">{{ 'By: ' + cardData?.author || '' }}</div> -->
        <p *ngIf="cardData?.footer" [ngClass]="cardData.cardCss?.footer" class="pt-4 text-xs">
          <span class="sr-only">Footer:</span> {{ cardData?.footer || ''}}
        </p>
      </a>
    </ng-container>

    <!-- Impact layout -->
    <!-- <ng-template #impactLayout>
      <div [ngClass]="cardData.cardCss?.mainCard" class="cursor-pointer" (click)="view(cardData.id)"
        (keydown.enter)="view(cardData.id)" (keydown.space)="view(cardData.id)" role="button" tabindex="0"
        [attr.aria-label]="'View ' + cardData?.title">

        <ng-container *ngIf="cardData?.sasToken; else defaultImage">
          <img [src]="generateUrlWithSasToken(cardData.sasToken, cardData.img)"
            [alt]="'image for ' + cardData?.title + ' card' || 'Impact card thumbnail'"
            [ngClass]="cardData.cardCss?.image" class="relative" />
        </ng-container>

        <ng-template #defaultImage>
          <div [ngClass]="cardData.cardCss?.image"
            [style.backgroundImage]="'url(' + generateUrlWithSasToken(cardData.sasToken, cardData.img) + ')'" role="img"
            [attr.aria-label]="'Thumbnail for ' + (cardData?.title || 'Impact video')">
          </div>
        </ng-template>

        <div [ngClass]="cardData.cardCss?.body">
          <div *ngIf="cardData?.title" [ngClass]="cardData.cardCss?.title" class="font-semibold pt-5 px-5 text-limit-4">
            {{ cardData?.title }}
          </div>
          <div class="px-5 mt-auto pb-4">
            <p *ngIf="cardData?.footer" [ngClass]="cardData.cardCss?.footer" class="pt-4 text-xs">
              <span class="sr-only">Footer:</span> {{ cardData?.footer }}
            </p>
          </div>
        </div>
      </div>
    </ng-template> -->

  </ng-container>
</div>
